package com.ijoin.ui.payment

import kotlinx.datetime.Instant

data class PaymentFlowArgs(
    val eventId: String,
    val bookingId: Long? = null,
    val quantity: Int? = null,
    val priceTierName: String? = null,
    val overrideAmount: Double? = null,
    val currency: String? = null,
    val occurrenceDateTime: Instant? = null,
    val successUrl: String? = null,
    val cancelUrl: String? = null,
)
